module.exports = __webpack_public_path__ + "dropoff-box.74211d37aad5705daa89920341c28953.svg";